module.exports = __webpack_public_path__ + "static/media/appi.c0981a18.svg";